const STORAGE_KEY = "nitfisio_recent_searches";
const MAX_RECENT = 5;

export function getRecentSearches(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function addRecentSearch(term: string) {
  const cleaned = term.trim();
  if (cleaned.length < 2) return;
  const current = getRecentSearches().filter((s) => s !== cleaned);
  const updated = [cleaned, ...current].slice(0, MAX_RECENT);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
}

export function clearRecentSearches() {
  localStorage.removeItem(STORAGE_KEY);
}
